// extracted by mini-css-extract-plugin
export default {"utility-input":"xmF3c1","utilityInput":"xmF3c1"};